import React from 'react';
import {Card} from "../../../../components/card/card.jsx";
import DutyAttendanceGauge from "./duty-attendance-gauge.jsx";
import DutyBarGraph from "./duty-bar-graph.jsx";
import DutyAttendancePriority from "./duty-attendance-priority.jsx";
import DutyProgressBar from "./duty-progress-bar.jsx";
import DashCard from "./dash-card.jsx";
import {getAssetPath} from "../../../../utils/get-asset-path.js";

const ARROW_ICON = getAssetPath("/img/dashboard-svg/arrow.svg");

const DutyAttendanceCard = ({ graphData }) => {
    const attendanceTotal =
        graphData.attendanceInProgress.inProgress + graphData.attendanceInProgress.onHold;

    const calcAvgTime = (value) => {
        let num;
        let unit;

        if (value >= 86400) {
            num = Math.floor(value / 86400);
            unit = 'Dias';
        } else if (value >= 3600) {
            num = Math.floor(value / 3600);
            unit = 'Horas';
        } else if (value >= 60) {
            num = Math.floor(value / 60);
            unit = 'Min';
        } else {
            num = Math.floor(value);
            unit = 'Seg';
        }

        return {num, unit}
    }

    const gaugeCards = [
        {
            data: graphData.attendanceInProgress.inProgress,
            title: "Em andamento",
            avgTime: calcAvgTime(graphData.availableAndEngageTime.averageInProgressTime)
        },
        {
            data: graphData.attendanceInProgress.onHold,
            title: "Em espera",
            avgTime: calcAvgTime(graphData.availableAndEngageTime.averageOnHoldTime)
        }
    ];

    return (
        <Card className={"dash-main-card col-span-3"}>
            <Card.Header className={"border-b-0! bg-transparent"}>
                <Card.Title className={"bg-transparent text-white text-center w-full text-(length:--font-lg)! translate-y-1.5"}>Atendimentos</Card.Title>
            </Card.Header>

            <Card.Body className={"flex-1 min-h-0 grid grid-cols-12 gap-(--dash-gap-md) px-(--dash-pad-md)! pb-(--dash-pad-md)!"}>
                <DashCard className={"col-span-4 min-h-0 flex flex-col"}>
                    <h3 className={"shrink-0 text-center text-[#AAAAAA] text-(length:--font-md)!"}>Status</h3>

                    <section className={"min-h-0 flex-1 grid grid-cols-[minmax(0,1fr)_max-content_minmax(0,1fr)] grid-rows-[1fr_auto] gap-x-[clamp(0.25rem,0.33vw,0.625rem)] gap-y-(--dash-gap-sm) px-[clamp(1rem,1.42vw,3rem)]!"}>
                        <div className={"min-h-0 col-start-1 row-start-1 flex flex-col items-center"}>
                            <div className={"flex-1 min-h-0 w-full"}>
                                <DutyAttendanceGauge
                                    data={gaugeCards[0].data}
                                    title={gaugeCards[0].title}
                                    total={attendanceTotal}
                                />
                            </div>

                            <img src={ARROW_ICON} alt="" className={"h-(--font-lg) mb-4"}/>
                        </div>

                        <div className={"min-h-0 col-start-3 row-start-1 flex flex-col items-center"}>
                            <div className={"flex-1 min-h-0 w-full"}>
                                <DutyAttendanceGauge
                                    data={gaugeCards[1].data}
                                    title={gaugeCards[1].title}
                                    total={attendanceTotal}
                                />
                            </div>

                            <img src={ARROW_ICON} alt="" className={"h-(--font-lg) mb-4"}/>
                        </div>

                        <DashCard counterCard className={"col-start-1 row-start-2 w-3/5! justify-self-center text-center p-(--dash-pad-sm)! mb-8"}>
                            <h2 className={"text-(length:--font-lg)! font-bold text-[#F4FFFF]!"}>{gaugeCards[0].avgTime.num}</h2>
                            <p className={"text-(length:--font-sm)! text-[#AAAAAA]!"}>{gaugeCards[0].avgTime.unit}</p>
                        </DashCard>

                        <span className={"col-start-2 row-start-2 self-center text-[clamp(0.75rem,0.88vw,1.25rem)]! whitespace-nowrap text-[#AAAAAA] -translate-y-4"}>Tempo médio</span>

                        <DashCard counterCard className={"col-start-3 row-start-2 w-3/5! justify-self-center text-center p-(--dash-pad-sm)! mb-8"}>
                            <h2 className={"text-(length:--font-lg)! font-bold text-[#F4FFFF]!"}>{gaugeCards[1].avgTime.num}</h2>
                            <p className={"text-(length:--font-sm)! text-[#AAAAAA]!"}>{gaugeCards[1].avgTime.unit}</p>
                        </DashCard>
                    </section>
                </DashCard>

                <DashCard className={"min-h-0 grid grid-cols-1 grid-rows-2 col-span-4 px-(--dash-pad-sm)! gap-0"}>
                    <DutyBarGraph
                        data={graphData.attendanceSource}
                        title={"Origem"}
                        titleClassName="mb-0! leading-none"
                        barWidth="40%"
                        barCategoryGap="40%"
                        fontSizeScale={1.15}
                    />

                    <DutyBarGraph
                        data={graphData.attendanceNature}
                        title={"Naturezas"}
                        titleClassName="mb-0! leading-none"
                        barWidth="40%"
                        barCategoryGap="40%"
                        fontSizeScale={1.15}
                    />
                </DashCard>

                <DashCard className={"min-h-0 grid grid-cols-1 grid-rows-[5fr_auto] col-span-4 px-(--dash-pad-lg)!  py-(--dash-pad-md)! gap-(--dash-gap-sm)"}>
                    <DutyAttendancePriority
                        data={graphData.attendancePriorityAndType}
                        height={"100%"}
                    />

                    <DutyProgressBar
                        data={graphData.attendancePriorityAndType}
                        total={graphData.attendanceInProgress.onHold}
                    />
                </DashCard>
            </Card.Body>
        </Card>
    );
};

export default React.memo(DutyAttendanceCard);
